"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getImgSrcFromBgImg;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.replace.js");

/**
 * @file 提取背景图片
 * @author zhangyanting
 */

/**
 * 获取作为背景图片的图片地址
 * @param {Object} bgImg dom对象
 * @private
 */
function getImgSrcFromBgImg(bgImg) {
  var imgSrc;
  var matches = bgImg.match(/url\(.*?\)/g);

  if (matches && matches.length) {
    var urlStr = matches[matches.length - 1];
    var innerUrl = urlStr.replace(/^url\([\'\"]?/, '').replace(/[\'\"]?\)$/, '');

    if (/^http/.test(innerUrl) || /^\/\//.test(innerUrl)) {
      imgSrc = innerUrl;
    }
  }

  return imgSrc;
}